
import { defineComponent, PropType } from 'vue'

import { VideoAttributes } from '@/types/models/video'
import VideoThumbnailHQ from '@/components/VideoThumbnailHQ.vue'
import { toArray } from '@/utils/array'

export default defineComponent({
  props: {
    videos: {
      type: Array as PropType<VideoAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  components: { VideoThumbnailHQ },
  setup() {
    return {
      toArray,
    }
  },
})
